// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymentsCheckoutPaypalForm__button","authForm":"PaymentsCheckoutPaypalForm__authForm"};